import React from 'react'
import styled from 'styled-components'

const Icon = styled.i`
  font-size: 14px;
  color: ${props => props.theme.editIconFontColor};
  cursor: pointer;
`

const RemoveIcon = props => <Icon className="fa fa-trash-alt" {...props} />

export default RemoveIcon;
